export default {
  OK_STATUS: 200,
  NO_CONTENT_STATUS: 204,
  BAD_REQUEST_STATUS: 400,
  SERVER_ERROR_STATUS: 500,
  UNAUTHORIZED_STATUS: 401,
  DENIED_STATUS: 403,
  NOT_FOUND_STATUS: 404,
}